import { render, staticRenderFns } from "./wsSidebarBanner.vue?vue&type=template&id=882fd526&scoped=true&"
import script from "./wsSidebarBanner.vue?vue&type=script&lang=js&"
export * from "./wsSidebarBanner.vue?vue&type=script&lang=js&"
import style0 from "./wsSidebarBanner.vue?vue&type=style&index=0&id=882fd526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882fd526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
